import { DateOutputStr } from 'utils/DateOutput';
import { sub } from 'date-fns';

export const DownloadConsolidatedProtocols = {
  protocolNumber: "",
  startPeriod: DateOutputStr(sub(new Date(), { months: 3 }).toISOString(), 'yyyy-MM-dd'),
  lastPeriod: DateOutputStr(new Date().toISOString(), 'yyyy-MM-dd'),
  keyword: "",
  bus: [],
  categories: [],
  reasons: [],
  responsibleGroups: [],
  subsidiaryIds: [],
  phaseStatus: [],
  brands: [],
  statusType: [0, 1],
  sortBy: 'createdDate',
  sortDirection: 'desc',
  protocolOrigin: 'Employee'
}